import React from 'react';
import classnames from 'classnames';
import parse from 'html-react-parser';

import * as st from './Terms.module.scss';

import termsData from 'static/temp/terms-data';

const Terms = () => {
  return (
    <div className={classnames(st.wrap, 'cr-wrap')}>
      <div className={st.top}>
        <h2 className="cr-h2">Terms & Conditions</h2>
        <p className="cr-lead cr-text-2">
          Version {termsData.version} — {termsData.date}
        </p>
      </div>
      <div className={st.content}>{parse(termsData.termsStr)}</div>
    </div>
  );
};

export default Terms;
